export default {
  menuItems: "Menu Items",
  manageRestaurantMenu: "Manage your restaurant menu",
  addItem: "Add Item",
  searchItemName: "Search item name",
  allCategories: "All Categories",
  mainCourse: "Main Course",
  rice: "Rice",
  starters: "Starters",
  dessert: "Dessert",
  item: "Item",
  items: "Items",
  selected: "selected",
  enable: "Enable",
  disable: "Disable",
  image: "Image",
  category: "Category",
  price: "Price",
  status: "Status",
  action: "Action",
  noItemsFound: "No items found",
  available: "Available",
  unavailable: "Unavailable",

  //menuItemModal
   editItem: "Edit Item",
  addNewItem: "Add New Item",
  itemName: "Item Name",
  enterItemName: "Enter item name",
  select: "Select",
  enterPrice: "Enter price",
  portionSize: "Portion Size",
  itemImage: "Item Image",
  clickToUploadImage: "Click to upload image",
  saveItem: "Save Item",
  fillAllRequiredFields: "Fill all required fields",
  pleaseUploadValidImage: "Please upload a valid image",
  cancel: "Cancel",
  description: "Description"
};